// Components
import { EPaddingRuleType } from '@timeedit/types/lib/enums';
import type {
  TDirectPaddingRule,
  TObjectFilterCriteria,
  TPaddingRule,
  TTravelTimePaddingRule,
} from '@timeedit/types/lib/types';
// Types
import { TEDrawerSection } from '@timeedit/ui-components';
import ObjectCriteria from '../../../../components/ObjectCriteria';

interface ObjectCriteriaSectionProps {
  paddingRule: TPaddingRule;
  onChange: (key: string, value: any) => void;
  isExpand: boolean;
}

const ObjectCriteriaSection = ({
  paddingRule,
  onChange,
  isExpand,
}: ObjectCriteriaSectionProps) => {
  if (!paddingRule) return null;
  const { impactedObjects = [], objectsOnReservation = [] } =
    paddingRule.rule as
      | TDirectPaddingRule
      | (TTravelTimePaddingRule & {
          objectsOnReservation: TObjectFilterCriteria[];
        });
  return (
    <TEDrawerSection label="Object criteria">
      <div className="max-w-fit">
        <ObjectCriteria
          impactedObjects={impactedObjects}
          objectsOnReservation={objectsOnReservation}
          onChange={(val) =>
            onChange('rule', {
              ...paddingRule.rule,
              ...val,
            })
          }
          isExpand={isExpand}
          showImpact={paddingRule.paddingType === EPaddingRuleType.DIRECT}
        />
      </div>
    </TEDrawerSection>
  );
};

export default ObjectCriteriaSection;
